import axiosPrivate from "../utils/axiosPrivate";
import {
  COOKIES,
  LOCALSTORAGE,
  removeLocalStorage,
  enCryptionFlag,
} from "../utils/constants";

import { Cookies } from "react-cookie";
import { UpdateAccesToken } from "../utils/B2CLogin";
import { getRefreshTokenForlogin } from "./Login/services";
import { getAccessTokenWithRefresh } from "../utils/B2BRefresh";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { preparePayload } from "./Login/utils/helper";
import { getData, getString, setData, setString } from "../utils/storage";
import { FacilityType, userDetailsType } from "../layouts/utils/type";

const cookies = new Cookies();

const callApiWithRefreshedToken = async () => {
  const scopes = ["user.read"]; // Define your scopes
  let userid = getString(LOCALSTORAGE?.USER_ID, true);
  try {
    const res = await getAccessTokenWithRefresh(scopes);

    if (res) {
   
      const ACCESS_TOKEN= getString(COOKIES.ACCESS_TOKEN,true);

      let update_tok_payload = {
        LOGIN_TYPE: "W",
        USER_ID: userid,
        TOKEN: ACCESS_TOKEN,
      };

      let res1: { FLAG: boolean; MSG: string } =
        await UpdateAccesToken(update_tok_payload);

      return !!res1?.FLAG;
    } else {
      return false;
    }
  } catch (error: any) {
    toast.error(error);
    return false;
  }
};

export const callPostAPI = async (
  url: string,
  payload: any | null = null,
  functionCode: string | null = null,
  scanfFile?: any,
) => {
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("//")
  ) {
    toast.error("Absolute URLs not allowed in callApi");
    throw new Error(`Absolute URLs not allowed in callApi: ${url}`);
  }
  if (await TokenCheck()) {
    
    const facilityData = getData<FacilityType>("FACILITYID", false)
    const userData = getData<userDetailsType>("USER", true)

    const languageCode: string = getString(LOCALSTORAGE.LANGUAGE, false) || 'EN';
   
 
    const commonPayload = {
      USER_ID:userData?.USER_ID,
      LOGIN_TYPE: "W",
      FACILITY_ID:facilityData?.FACILITY_ID,
      FACILITY_TYPE: facilityData?.FACILITY_TYPE,
      PORTFOLIO_ID: "1",
      ROLE_ID: facilityData?.ROLE_ID ?? "",
      LANGUAGE_CODE: languageCode ?? userData?.DEFAULT_LANGUAGE ?? "EN",
      ROLE_HIERARCHY_ID: facilityData?.ROLE_HIERARCHY_ID ?? "",
      ROLETYPE_CODE: facilityData?.ROLETYPECODE ?? "",
      FUNCTION_CODE: functionCode,
      isExcelUpload: payload?.isExcelUpload ?? 0, // Add default or derived value
    };

    let finalpayload = commonPayload;

    if (payload) {
      finalpayload = { ...commonPayload, ...payload };
    }

    try {
      const encryptdata = preparePayload(
        finalpayload,
        scanfFile,
        enCryptionFlag,
      );
      const res = await axiosPrivate.post(
        `${globalThis._ENV_.REACT_APP_BASE_URL}${url}`,
        encryptdata,
      );
      if (res.status === 429) {
        const res = {
          FLAG: false,
          APIMSG: "Too many request at t time",
        };
        return res;
      } else if (url === "Upload/uploadExcelDataCommonWithoutEncryption") {
        return res?.data?.RESULT;
      } else if (res?.data?.FLAG === true || res?.data?.FLAG === 1) {
        return res?.data;
      } else if (res?.data?.FLAG === 0 || res?.data?.FLAG === false) {
        return res?.data;
      }
    } catch (error: any) {
      throw error;
    }
  } else {
    cookies.remove(COOKIES.ACCESS_TOKEN, {
      path: `${globalThis._ENV_.REACT_APP_CUSTOM_VARIABLE}`,
    });
    cookies.remove(COOKIES.REFERESH_TOKEN, {
      path: `${globalThis._ENV_.REACT_APP_CUSTOM_VARIABLE}`,
    });
    cookies.remove(COOKIES.LOGIN_TYPE, {
      path: `${globalThis._ENV_.REACT_APP_CUSTOM_VARIABLE}`,
    });
    removeLocalStorage();

    globalThis.location.href = `${globalThis._ENV_.REACT_APP_B2B_LOGIN_REDIRECT_URL}`;
  }
};


const TOKEN_REFRESH_BUFFER = 5 * 60 * 1000;

const getTokenSessionData = () => {
  const profile = sessionStorage.getItem("USER");

  const expiresIn = JSON.parse(
    sessionStorage.getItem("expiresIn") || "{}"
  );

  const refreshTok = getString(
    COOKIES.REFERESH_TOKEN,
    true
  );

  const accessTok = getString(
    COOKIES.ACCESS_TOKEN,
    true
  );

  const loginType = getString(
    COOKIES.LOGIN_TYPE,
    true
  );

  return {
    profile,
    expiresIn,
    refreshTok,
    accessTok,
    loginType,
  };
};

const handleB2BToken = async (
  profile: string | null,
  expiresIn: any,
  accessTok: any
): Promise<boolean> => {
  if (!profile || !expiresIn || !accessTok) {
    return false;
  }

  const decodedToken: any = jwtDecode(accessTok);

  const expirationTime = decodedToken.exp * 1000;
  const currentTime = Date.now();

  const tokenNeedsRefresh =
    expirationTime - currentTime <= TOKEN_REFRESH_BUFFER;

  if (!tokenNeedsRefresh) {
    return true;
  }

  try {
    return await callApiWithRefreshedToken();
  } catch (error: any) {
    toast.error(error);
    return false;
  }
};

const handleB2CToken = async (
  profile: string | null,
  refreshTok: any,
  expiresIn: any,
  accessTok: any
): Promise<boolean> => {
  if (!profile || !refreshTok || !expiresIn || !accessTok) {
    return false;
  }

  const notBeforeTimestamp = expiresIn.not_before;
  const idTokenExpiresIn = expiresIn.id_token_expires_in;

  const expirationTime =
    (notBeforeTimestamp + idTokenExpiresIn) * 1000;

  const refreshTime =
    expirationTime - TOKEN_REFRESH_BUFFER;

  const currentTime = Date.now();

  if (currentTime >= refreshTime) {
    return RefreshTokenFunc();
  }

  return true;
};

const TokenCheck = async (): Promise<boolean> => {
  const {
    profile,
    expiresIn,
    refreshTok,
    accessTok,
    loginType,
  } = getTokenSessionData();

  if (loginType === "B2B") {
    return handleB2BToken(
      profile,
      expiresIn,
      accessTok
    );
  }

  if (loginType === "B2C") {
    return handleB2CToken(
      profile,
      refreshTok,
      expiresIn,
      accessTok
    );
  }
  return false;
};

const RefreshTokenFunc = async () => {
  let flag = false;

  let ref_tok_exists = getString(COOKIES.REFERESH_TOKEN, true
  );
  if (
    ref_tok_exists !== undefined &&
    ref_tok_exists !== null &&
    ref_tok_exists !== ""
  ) {
    let token_payload = {
      TOKEN: ref_tok_exists,
    };
    let res = await getRefreshTokenForlogin(token_payload);
    if (res) {
      let userid = getString(LOCALSTORAGE?.USER_ID, true) ?? "";
      if (userid !== undefined && userid !== null && userid !== "") {
       
       setString(LOCALSTORAGE.ACCESS_TOKEN, res?.data?.id_token, true);
        
        setString(LOCALSTORAGE.REFERESH_TOKEN, res?.data?.refresh_token, true);

        let expiresIn: any = {
          not_before: res?.data?.not_before,
          id_token_expires_in: res?.data?.id_token_expires_in,
        };
       setData("expiresIn", expiresIn, false);
        if (res?.status === 200) {
          let update_tok_payload = {
            LOGIN_TYPE: "W",
            USER_ID: userid,
            TOKEN: res?.data?.id_token,
          };
          await UpdateAccesToken(update_tok_payload);
          flag = true;
        }
      }
    } else {
      flag = false;
    }
  }
  return flag;
};

export const FILESACNNING = async (url: any, payload: any = null) => {
  await axiosPrivate.post(url, payload);
};
